import { throttle } from 'lib/tools/utils'
// 滚动方向mixin 使用方式
// 1，watch scrollDirection (为1时，表示向上滑动，0为向下滑动)
const directionScroll = {
  data() {
    return {
      scrollDirection: 0
    }
  },
  mounted() {
    this.beforeScrollTop =
      document.documentElement.scrollTop ||
      window.pageYOffset ||
      document.body.scrollTop

    this.throttleScroll = throttle(this._scroll, 100, 100)
    window.addEventListener('scroll', this.throttleScroll, false)
  },
  destroyed() {
    window.removeEventListener('scroll', this.throttleScroll, false)
  },
  computed: {
    directionScrollMin() {
      return 0
    }
  },
  methods: {
    _scroll() {
      const afterScrollTop =
        document.documentElement.scrollTop || document.body.scrollTop

      typeof this.directionScrolling === 'function' &&
        this.directionScrolling(afterScrollTop)
      if (
        afterScrollTop < 0 ||
        afterScrollTop > document.body.scrollHeight - window.screen.availHeight
      ) {
        return
      }

      if (afterScrollTop < this.directionScrollMin) return

      this.scrollDirection = afterScrollTop - this.beforeScrollTop > 0 ? 1 : 0
      this.beforeScrollTop = afterScrollTop
    }
  }
}

export default directionScroll
